































































































import Base from '@/views/Base';
import { Component, Prop } from 'vue-property-decorator';
import { ElementListItem } from '@/models/Presentation';
import ElementThumbnail from '@/views/presentation/components/ElementThumbnail.vue';
import DownloadThumbnail from '@/views/presentation/components/DownloadThumbnail.vue';

@Component({
  components: { DownloadThumbnail, ElementThumbnail }
})
export default class ElementCard extends Base {
  @Prop({ type: Number, required: true }) columns!: number;
  @Prop({ required: true }) item!: ElementListItem;
  @Prop() selectedElement!: ElementListItem | null;
  @Prop() index!: number;

  nameEdit = false;
  preventBlur = false;

  oldTitle = '';

  editName(): void {
    if (this.item.type === 'SURVEY' || this.item.type === 'SURVEY_FORM') {
      this.$emit('edit');
      return;
    }
    this.oldTitle = this.item.name;
    this.nameEdit = true;
    this.$nextTick(() => (this.$refs['name-input'] as HTMLInputElement).focus());
  }

  handleBlur(): void {
    if (!this.preventBlur) this.updateName();
    this.preventBlur = false;
  }

  handleKeydown(): void {
    this.preventBlur = true;
    this.updateName();
  }

  handleEsc(): void {
    this.preventBlur = true;
    this.item.name = this.oldTitle;
    this.nameEdit = false;
  }

  updateName(): void {
    this.nameEdit = false;
    this.$emit('update-name');
  }

  get isSelected(): boolean {
    return this.item.id === this.selectedElement?.id;
  }

  escapeHtml(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.innerText;
  }
}
